import { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

/**
 * Category picker: dropdown populated from an admin-managed list plus a
 * "Lainnya" option that reveals a custom text input.
 *
 * - `endpoint` defaults to /api/categories (business). Pass /blog-categories for blog.
 * - `value` is the category name string. On change, parent receives the final name.
 */
export default function CategoryPicker({ value, onChange, endpoint = "/categories", testId = "category", disabled = false }) {
  const [cats, setCats] = useState([]);
  const [mode, setMode] = useState("preset"); // "preset" | "custom"
  const [custom, setCustom] = useState("");

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(endpoint); setCats(data || []); }
      catch (err) { console.error("CategoryPicker load failed:", err); }
    })();
  }, [endpoint]);

  const names = useMemo(() => cats.map((c) => c.name).filter((n) => n && n.toLowerCase() !== "lainnya"), [cats]);

  // Initialize mode from incoming value once cats loaded
  useEffect(() => {
    if (!cats.length) return;
    if (!value) return;
    if (names.includes(value)) { setMode("preset"); setCustom(""); }
    else { setMode("custom"); setCustom(value === "Lainnya" ? "" : value); }
  }, [cats, value, names]);

  const handleSelect = (e) => {
    const v = e.target.value;
    if (v === "__lainnya__") { setMode("custom"); onChange(custom || "Lainnya"); }
    else { setMode("preset"); setCustom(""); onChange(v); }
  };

  const handleCustom = (e) => {
    const v = e.target.value; setCustom(v);
    onChange(v.trim() || "Lainnya");
  };

  const selectValue = mode === "custom" ? "__lainnya__" : (names.includes(value) ? value : (names[0] || ""));

  return (
    <div className="space-y-2">
      <select value={selectValue} onChange={handleSelect} disabled={disabled} className="input-bizma" data-testid={testId}>
        <option value="" disabled>-- Pilih Kategori --</option>
        {names.map((n) => <option key={n} value={n}>{n}</option>)}
      </select>
    </div>
  );
}
